/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M8.167 10H4.373l4.294-4.293V9.5a.5.5 0 01-.5.5zm12-6h-11a.5.5 0 00-.354.147l-6 6a.5.5 0 00-.146.353v15a.5.5 0 00.5.5h10.352a.5.5 0 00.452-.715C13.333 24.667 12 22.667 12 20c0-4.25 4.667-7.087 8.239-6.59a.501.501 0 00.428-.497V4.5a.5.5 0 00-.5-.5z" _fill="#fff"/><path pid="1" d="M24 23.745l.784-1.078 3.775 2.743a.667.667 0 11-.784 1.078L24 23.745z" _fill="#fff"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M19.333 16a4.673 4.673 0 00-4.666 4.667 4.673 4.673 0 004.666 4.666A4.673 4.673 0 0024 20.667 4.673 4.673 0 0019.333 16zm0-1.333c-3.307 0-6 2.692-6 6 0 3.307 2.693 6 6 6 3.308 0 6-2.693 6-6 0-3.308-2.692-6-6-6z" _fill="#fff"/>'
  }
})
